<template>
  <article id="lotto-wrapper" class="contents-wrapper">
    <button @click="getBuySummary">조회</button>
    <div id="lotto-recent">
      <div id="this-round">
        <div class="description">
          <div class="round-info">
            <div class="label">다음 회차</div>
            <div class="game-number">{{ res.drwNo }}</div>
          </div>
          <div class="drw-date">
            추첨일
            {{ getDateFormat(res.drwNoDate, "yyyy년 MM월 dd일 ") }} 8시 35분
          </div>
        </div>

        <div class="buy-list-area">
          <div class="progress-buy-title">구매내역</div>
          <div
            class="progress-item"
            v-for="progress in res.progressList"
            :key="progress.drwNo"
          >
            <LottoBuyGame :lottoGame="progress" />
          </div>
        </div>
      </div>
      <div id="past-round">
        <!-- 최신 5회차 구매내역 -->
        <div
          class="result-item"
          v-for="game in res.resultList"
          :key="game.result.drwNo"
        >
          <!-- 당첨정보 -->
          <LottoResult :lottoResult="game.result" />
          <div class="game-buy-list">
            <div class="game-buy-title" v-if="game.gameBuyList.length > 0">
              구매내역
            </div>
            <div class="game-buy-title-no" v-else><div>구매내역 없음</div></div>
            <div
              class="game-buy-item"
              v-for="gameBuy in game.gameBuyList"
              :key="gameBuy.drwNo"
            >
              <LottoBuyGame :lottoGame="gameBuy" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <pre id="lotto-recent-temp">{{ recentRes }}</pre> -->
  </article>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import UtilMixin from "@/common/mixins/UtilMixin";
import { LottoGame, LottoGameBuySummaryResponse } from "../class";
import LottoBuyGame from "../components/LottoBuyGame.vue";
import LottoResult from "../components/LottoResult.vue";

export default defineComponent({
  name: "LottoRecentView",
  components: {
    LottoBuyGame,
    LottoResult,
  },
  setup() {
    return {};
  },

  data() {
    return {
      //
      mixStandardResult: [] as LottoGame[],
      recentRes: {},
      res: {} as LottoGameBuySummaryResponse,
    };
  },
  mixins: [UtilMixin],
  computed: {
    //
  },
  methods: {
    //
    async getBuySummary() {
      //
      this.recentRes = "";
      console.log("getBuySummary");
      const res = await this.getApi().lotto().getLottoGameBuySummary();
      console.log("res : ", res);
      this.res = res;
      this.recentRes = JSON.stringify(res, null, 2);
    },
  },
  created() {
    this.getBuySummary();
  },
});
</script>
